export enum OnboardingVerificationItemName {
  Agreement = 'AGREEMENT',
  BankAccount = 'BANK_ACCOUNT',
  Documents = 'DOCUMENTS',
  IdentityVerification = 'IDENTITY_VERIFICATION',
  Kyb = 'KYB',
  LienFiling = 'LIEN_FILING',
  SignUp = 'SIGN_UP',
  BusinessPhoneVerification = 'BUSINESS_PHONE_VERIFICATION',
}

export enum OnboardingVerificationItemOutcome {
  Approved = 'Approved',
  ManualReview = 'Manual Review',
  Rejected = 'Rejected',
}
export const OnboardingVerificationItemOutcomeUnset = null;

export enum OnboardingVerificationItemStatus {
  Completed = 'Completed',
  Pending = 'Pending',
  Submitted = 'Submitted',
}

export type OnboardingVerification = {
  createdAt?: string;
  id?: string;
  name: OnboardingVerificationItemName;
  outcome: OnboardingVerificationItemOutcome;
  status: OnboardingVerificationItemStatus;
}
